import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiEndpoint } from '@shared/shared/enums/api-endpoints.enum';
import { concat, Observable, of, Subject } from 'rxjs';
import { filter, map, shareReplay, switchMap } from 'rxjs/operators';
import { CustomisableVariables } from '../models/customisable-variables';

@Injectable({
  providedIn: 'root',
})
export class CustomisableVariablesService {
  public variables: Observable<CustomisableVariables>;
  private fetch$ = new Subject<void>();

  constructor(private http: HttpClient) {
    const defaultVariables$ = of({});
    const variables$ = this.http.get(ApiEndpoint.CUSTOMISABLE_VARIABLES).pipe(filter((vars) => !!vars));
    const updatedVariables$ = this.fetch$.pipe(switchMap(() => variables$));

    this.variables = concat(defaultVariables$, variables$, updatedVariables$).pipe(
      shareReplay({ bufferSize: 1, refCount: false })
    );
  }

  public invalidateVariables() {
    this.fetch$.next();
  }

  public getContactNumber(): Observable<string> {
    return this.variables.pipe(
      filter((res) => res && res !== null),
      map((res) => (res.toll_free_contact_number ? res.toll_free_contact_number : res.contact_number_general))
    );
  }
}
